
import { React, useState, useEffect } from "react";
import ReactEcharts from "echarts-for-react";
import * as echarts from "echarts/core";
import { BarChart } from "echarts/charts";
import {
  GridComponent,
  TooltipComponent,
  TitleComponent,
} from "echarts/components";
import { CanvasRenderer } from "echarts/renderers";
import {
  getDate,
  getTime,
  getDay,
  formatYaxisNumber,
} from "components/common/dateTime";
import { useWindowSize } from "services/resizeservice";

function RevenueComponent(props) {
  const [echartInstance, setEchartInstance] = useState(null);
  const size = useWindowSize();

  useEffect(() => {
    echartInstance?.resize();
  }, [size.width]);

  echarts.use([
    TitleComponent,
    TooltipComponent,
    GridComponent,
    BarChart,
    CanvasRenderer,
  ]);

  var xAxisData = [];
  var yAxisRevenue = [];

  if (props.data != undefined) {
    props.data.map(function (obj) {
      if (props.selectValue === "HOUR_24" || props.selectValue === "HOUR_12") {
        xAxisData.push(getTime(obj.endDate));
      } else if (props.selectValue === "WEEK") {
        xAxisData.push(getDay(obj.endDate));
      } else {
        xAxisData.push(getDate(obj.endDate));
      }
      yAxisRevenue.push(Number(obj.revenue).toFixed(2));
    });
  }

  if (props.selectValue == "168") {
    xAxisData = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  }

  const options = () => ({
    tooltip: {
      trigger: "item",
    },
    color: ["#f78527"],
    xAxis: {
      type: "category",
      data: xAxisData,
      name: "Time",
      nameLocation: "middle",
      // nameGap: 30,
      nameGap: xAxisData?.every((element) => element === null) ? 20 : 40,
      axisTick: {
        show: false,
      },
      nameTextStyle: {
        fontFamily: "JioType",
        fontStyle: "normal",
        fontWeight: 300,
        fontSize: "12",
        color: "#000000",
      },
      axisLabel: {
        rotate:
          props.selectValue === "WEEK_2" ||
            props.selectValue === "MONTH" ||
            props.selectValue === "MONTH_3"
            ? 30
            : 0,
      }
    },
    grid: {
      left: "11%",
      right: "4%",
      bottom: "20%",
      containLabel: true,
      height: "60%",
    },
    legend: {
      top: "1%",
      icon: "circle",
      left: "15",
      color: "#bad4d4",
      top: "12px",
      bottom: "12px",
      itemWidth: 12,
      itemGap: 40,
      textStyle: {
        fontSize: "11",
        fontFamily: "JioType",
        fontStyle: "normal",
        color: "#C1C1C1",
      },
    },
    yAxis: {
      type: "value",
      name: "Amount",
      nameLocation: "middle",
      nameGap: 32,
      axisLabel: {
        formatter: formatYaxisNumber,
      },
      // min: 0,
      // max: 200,
      nameTextStyle: {
        fontFamily: "JioType",
        fontStyle: "normal",
        fontWeight: 300,
        fontSize: "12",
        color: "#000000",
      },
    },
    series: [
      {
        name: "Revenue",
        symbolSize: 10,
        smooth: true,
        showSymbol: true,
        // data: [120, 200, 150, 80, 70, 110, 130],
        data: yAxisRevenue,
        type: "bar",
      },
    ],
  });
  return (
    <ReactEcharts
      echarts={echarts}
      notMerge={true}
      lazyUpdate={true}
      theme={"theme_name"}
      onChartReady={(instance) => {
        setEchartInstance(instance);
      }}
      opts={{ renderer: "svg" }}
      option={options()}
    />
  );
}

export default RevenueComponent;
